import React, { useContext, useEffect, useState } from 'react';
import { ThemeContext } from '../../context/ThemeContext';
import { SetupContext } from '../../context/SetupContext';

import CustomButton from '../Componentization/CustomButton';
import CustomText from '../../styles/CustomText';
import { useNavigate, useLocation } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { checkHeaderText } from '../../store';

interface Props {
    // 필요한 prop 타입 정의 (필요에 따라 추가)
}

const CreateManualWallet: React.FC<Props> = () => {
    const { theme } = useContext(ThemeContext)
    let location = useLocation();
    let navigate = useNavigate();
    let dispatch = useDispatch();
    const { t } = useTranslation();
    const setupContext = useContext(SetupContext);

    useEffect(() => {
		dispatch(checkHeaderText({ "link": "CreateManualWallet", "title": '' }))
	}, [])

    const initializeWallet = async () => {
        navigate(`/WalletProtection`, { replace: true, state: { } });
    }

    const recoveryWallet = async () => {
        navigate(`/WalletRecovery`, { replace: true, state: { } });
    }

    const handleTermsLink = async () => {
        let url = setupContext.commonInfo?.term_url || ''
        try {
            await window.open(url, '_blank');
        } catch (error) {
            console.log('Failed to open Terms URL: ', error)
        }
    }

    const styles = {
        header: {
            width: "100%",
            marginBottom: 20
        } as React.CSSProperties,
        title: {
            fontSize: '24px', // px 단위 추가
            textAlign: 'left',
        } as React.CSSProperties,
        subtitle: {
            fontSize: '16px',
            textAlign: 'left',
            marginTop: '15px',
        } as React.CSSProperties,
        imageContainer: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            paddingBottom: '65px'
        } as React.CSSProperties,
        image: {
            width: '180px',
            height: '180px',
        } as React.CSSProperties,
        footer: {
            width: "100%"
        } as React.CSSProperties,
        checkboxContainer: {
            display: 'flex',
            alignItems: 'center',
            marginBottom: '24px',
            width: '100%',
        } as React.CSSProperties,
        checkboxBase: {
            width: '22px',
            height: '22px',
            borderRadius: '5px',
            border: `1px solid ${theme.border_05}`,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginRight: '5px',
        } as React.CSSProperties,
        label: {
            fontSize: '16px',
            color: theme.text_01,
            display: 'flex',
            gap: '5px'
        } as React.CSSProperties,
        underline: {
            textDecoration: 'underline', // React 웹에서는 textDecorationLine 대신 textDecoration 사용
        } as React.CSSProperties,
        buttonPrimary: {
            backgroundColor: theme.button_02,
            padding: '12px',
            borderRadius: '10px',
            marginBottom: '12px',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            height: '54px',
            justifyContent: 'center',
        } as React.CSSProperties,
        buttonPrimaryText: {
            color: theme.text_01,
            fontSize: '16px',
            textAlign: 'center', // textAlignVertical은 웹에서는 textAlign으로 처리
        } as React.CSSProperties,
        buttonSecondary: {
            padding: '12px',
            borderRadius: '10px',
            marginBottom: '12px',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            height: '54px',
            justifyContent: 'center',
        } as React.CSSProperties,
        buttonSecondaryText: {
            fontSize: '16px',
            textAlign: 'center', // textAlignVertical을 대체
        } as React.CSSProperties,
        divider: {
			width: 1,
            height: 30,
			// backgroundColor: theme.divider_background_01
		} as React.CSSProperties,
    };

    return (
        <div className='container' style={{ backgroundColor: theme.background_normal }}>
            <div style={styles.header}>
                <CustomText weight="medium" style={{ ...styles.title, color: theme.label_strong }}>
                    {t('wallet_manual_create_message_01')}
                </CustomText>
                <CustomText weight="medium" style={{ ...styles.title, color: theme.label_strong }}>
                    {t('wallet_manual_create_message_02')}
                </CustomText>
                <CustomText style={{ ...styles.subtitle, color: theme.label_alternative }}>
                    {t('main_message_03')}
                </CustomText>
            </div>
            <div style={styles.imageContainer}>
                <img
                    src={`./img/login_wallet_icon.png`} // process.env.PUBLIC_URL로 경로 설정
                    alt="Login Wallet"
                    style={{ ...styles.image, objectFit: 'contain' }} // objectFit으로 이미지 크기 조정
                />
            </div>
            <div style={styles.footer}>
                <CustomButton
                    containerStyle={{
                        ...styles.buttonSecondary, // 기존 스타일
                    }}
                    textStyle={{
                        ...styles.buttonSecondaryText, // 기존 스타일 병합
                        color: theme.label_strong, // 추가 스타일 병합
                    }}
                    onPress={() => { initializeWallet() }}
                    text={t('main_message_06')}
                    withBackground={true}
                    backgroundColor={theme.fill_alternative}
                />
                <CustomButton
                    containerStyle={{
                        ...styles.buttonSecondary, // 기존 스타일 병합
                    }}
                    textStyle={{
                        ...styles.buttonSecondaryText, // 기존 스타일 병합
                        color: theme.label_strong, // 추가 스타일 병합
                    }}
                    onPress={() => { recoveryWallet() }}
                    text={t('main_message_07')}
                    withBackground={true}
                    backgroundColor={theme.fill_alternative}
                />
                
            </div>
        </div>
    )
}

export default CreateManualWallet
